import React, { forwardRef } from "react";

// Adăugăm forwardRef pentru a face componenta compatibilă cu ref
// dacă nu-l folosești, scoate-l:
const Page = forwardRef<HTMLDivElement, { children: React.ReactNode }>(({ children }, ref) => {
    return (
        <div ref={ref} className="pageDD">
            {children}
        </div>
    );
});

export default Page;
